// src/pages/MentionsLegalesPage.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Footer from '../components/Footer';

const MentionsLegalesPage = () => {
  const { t, i18n } = useTranslation();
  const isNotFr = i18n.language !== 'fr';

  return (
    <div className="pt-24 pb-12">
      <Helmet>
        <title>{t('legal.mentions.meta.title')}</title>
        <meta name="description" content={t('legal.mentions.meta.description')} />
        <link rel="canonical" href="https://hmonghearts.com/mentions-legales" />
      </Helmet>
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl font-bold mb-8 dark:text-gray-100">{t('legal.mentions.title')}</h1>

        {isNotFr && (
          <div className="mb-6 p-4 bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 rounded-xl text-sm text-amber-800 dark:text-amber-200">
            {t('legal.disclaimer')}
          </div>
        )}

        <div className="prose prose-gray max-w-none space-y-6 text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.mentions.article1.title')}
            </h2>
            <p>
              <span dangerouslySetInnerHTML={{ __html: t('legal.mentions.article1.p1') }} />{' '}
              <a
                href="https://hmonghearts.com"
                className="text-rose-600 dark:text-rose-400 hover:underline"
              >
                hmonghearts.com
              </a>
              {t('legal.mentions.article1.p1end')}
            </p>
            <ul className="list-none space-y-1 mt-2">
              <li>
                <strong>{t('legal.mentions.article1.companyName')}</strong> Archion Consulting
              </li>
              <li>
                <strong>{t('legal.mentions.article1.legalForm')}</strong>{' '}
                {t('legal.mentions.article1.legalFormValue')}
              </li>
              <li>
                <strong>SIRET :</strong> 948 312 632 00037
              </li>
              <li>
                <strong>SIREN :</strong> 948 312 632
              </li>
              <li>
                <strong>{t('legal.mentions.article1.vat')}</strong> FR76948312632
              </li>
              <li>
                <strong>{t('legal.mentions.article1.address')}</strong>{' '}
                {t('legal.mentions.article1.addressValue')}
              </li>
              <li>
                <strong>Email :</strong>{' '}
                <a
                  href="mailto:contact@hmonghearts.com"
                  className="text-rose-600 dark:text-rose-400 hover:underline"
                >
                  contact@hmonghearts.com
                </a>
              </li>
              <li>
                <strong>{t('legal.mentions.article1.director')}</strong> Marc Grudet
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.mentions.article2.title')}
            </h2>
            <p>{t('legal.mentions.article2.p1')}</p>
            <ul className="list-none space-y-1 mt-2">
              <li>
                <strong>Vercel Inc.</strong>
              </li>
              <li>440 N Barranca Ave #4133, Covina, CA 91723, USA</li>
              <li>
                <a
                  href="https://vercel.com"
                  className="text-rose-600 dark:text-rose-400 hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  vercel.com
                </a>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.mentions.article3.title')}
            </h2>
            <p>{t('legal.mentions.article3.p1')}</p>
            <p>{t('legal.mentions.article3.p2')}</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.mentions.article4.title')}
            </h2>
            <p>
              {t('legal.mentions.article4.p1')}{' '}
              <a
                href="/confidentialite"
                className="text-rose-600 dark:text-rose-400 hover:underline"
              >
                {t('legal.privacy.title')}
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.mentions.article5.title')}
            </h2>
            <p>
              {t('legal.mentions.article5.p1')}{' '}
              <a
                href="/confidentialite"
                className="text-rose-600 dark:text-rose-400 hover:underline"
              >
                {t('legal.privacy.title')}
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.mentions.article6.title')}
            </h2>
            <p>{t('legal.mentions.article6.p1')}</p>
            <p>
              {t('legal.mentions.article6.p2')}{' '}
              <a
                href="mailto:contact@hmonghearts.com"
                className="text-rose-600 dark:text-rose-400 hover:underline"
              >
                contact@hmonghearts.com
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-3">
              {t('legal.mentions.article7.title')}
            </h2>
            <p>{t('legal.mentions.article7.p1')}</p>
          </section>

          <p className="text-gray-400 text-xs mt-8">{t('legal.mentions.lastUpdated')}</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MentionsLegalesPage;
